import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=1a2f22d0&scoped=true"
import script from "./employee.vue?vue&type=script&lang=ts"
export * from "./employee.vue?vue&type=script&lang=ts"
import style0 from "./employee.vue?vue&type=style&index=0&id=1a2f22d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f22d0",
  null
  
)

export default component.exports